/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelSendWaitlistMessage =
  ({ entity, pageName, selectedFloorplanId }) =>
  (dispatch, getState) => {
    const floorplan = entity?.floorplans?.find((fp) => fp?.listingId === selectedFloorplanId)
    if (!floorplan) {
      return
    }
    const state = getState()
    const payload = getCommonProps({ state, entity: floorplan, pageName })
    payload[PROP_NAMES.BUILDING_IDS] = floorplan?.buildingId
    payload[PROP_NAMES.LISTING_IDS] = selectedFloorplanId
    Object.keys(payload).forEach(
      (key) => (payload[key] === undefined || !payload[key]) && delete payload[key]
    )
    track({ event: EVENT_NAMES.SEND_WAITLIST_MESSAGE, payload })
  }
